import { render, staticRenderFns } from "./about_banner.vue?vue&type=template&id=3e038124&scoped=true"
import script from "./about_banner.vue?vue&type=script&lang=js"
export * from "./about_banner.vue?vue&type=script&lang=js"
import style0 from "./about_banner.vue?vue&type=style&index=0&id=3e038124&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e038124",
  null
  
)

export default component.exports